/****************************************************************************************************************
* ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
* other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the
* applicable third party licensors or the open source community as the case may be and nothing here transfers the
* rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
* storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
* photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
* severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
*****************************************************************************************************************/
import { Component, ComponentFactoryResolver, Input, OnInit, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import * as async from 'async';

@Component({
    selector: 'dynamic-component-viewer',
    templateUrl: './dynamic-component-viewer.component.html',
    styleUrls: ['./dynamic-component-viewer.component.scss'],
    standalone: false
})
export class DynamicComponentViewerComponent implements OnInit {

  @Input() screenId: number;
  @Input() type: string;
  @Input() screenCode: string;
  @Input() uniqueId: any;
  @Input() dynamicParameters: any;
  factories: any;
  templateData: any;
  showSpinner: boolean = true;

  @ViewChild('templateHolder', { read: ViewContainerRef, static: false }) viewContainerRef: ViewContainerRef;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private commonService: CommonService) {
    this.factories = Array.from(this.componentFactoryResolver['_factories'].keys());
  }

  ngOnInit() {
    this.showSpinner = true;
    this.templateData = undefined;
    this.commonService.getScreen(this.screenId, this.screenCode, false, this.type).toPromise().then((response) => {
      if (response) {
        this.templateData = response;
        this.constructScreen();
      } else {
        this.showSpinner = false;
      }
    }).catch((error) => {
      this.showSpinner = false;
      console.log(error);
    });
  }

  constructScreen() {
    this.viewContainerRef.clear();
    var self = this;
    if (this.templateData && this.templateData.layout) {
      async.eachSeries(this.templateData.layout, function (element: any, elementCB) {
        self.commonService.createDynamicComponent(null, element.templateName, self.viewContainerRef, function (err, containerRef) {
          if (err) {
            return elementCB(err);
          }
          (<any>containerRef.instance).templateDraggable = false;
          (<any>containerRef.instance).elementDetail = element;
          (<any>containerRef.instance).viewOnly = true;
          (<any>containerRef.instance).screenId = self.uniqueId + '_' + self.screenId + '_' + self.templateData.screenId;
          if (self.dynamicParameters) {
            (<any>containerRef.instance).dynamicParameters = self.dynamicParameters;
          }
          containerRef.changeDetectorRef.detectChanges();
          (<any>containerRef.instance).constructScreen();
          elementCB();
        });
      }, function (err) {
        self.showSpinner = false;
      });
    } else {
      this.showSpinner = false;
    }
  }
}


